import React, { useState, useEffect } from 'react';
import './esqueciSenha.css';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { formEsqueciSenhaPJAN8 } from './FormSchema';
import { yupResolver } from '@hookform/resolvers/yup';
import useFetch from '../../../components/hooks/useFetch';
import { getIPAddress } from '../../../components/utils/GetIPAddress';
import { toast } from 'react-toastify';
import '../../../assets/css/custom-toast.css';
import InputCadastro from '../../../components/form/InputCadastro';
import Input from '../../../components/form/InputComLabel';
import { useLocation } from 'react-router-dom';
import InputNomeCompleto from '../../../components/form/InputNomeCompleto';

const EsqueciSenhaPJAN8 = () => {
  const navigate = useNavigate();
  const methods = useForm({ resolver: yupResolver(formEsqueciSenhaPJAN8) });
  //  const [meioEnvio, setMeioEnvio] = useState();
  const location = useLocation();
  const dadosUsuario = location.state;
  const [ipAddress, setIpAddress] = useState('');
  const [tentativas, setTentativas] = useState(0);
  const [temErro, setTemErro] = useState(false);

  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);

  //  const { request } = useFetch();

  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const handleSubmit = async (data) => {
    let campoComErro = null;
    if (dadosUsuario.usuarioExternoPJ.an8 != data.an8.toUpperCase().trim()) {
      campoComErro = 'AN8';
    } else {
      if (dadosUsuario.nome.trim() != data.nome.toUpperCase().trim()) {
        campoComErro = 'Razão Social';
      } else {
        if (
          dadosUsuario.usuarioExternoPJ.nomeFantasia &&
          dadosUsuario.usuarioExternoPJ.nomeFantasia.toUpperCase().trim() !=
            data.nomeFantasia.toUpperCase().trim()
        ) {
          campoComErro = 'Nome Fantasia';
        }
      }
    }

    if (campoComErro) {
      setTemErro(true);
      if (tentativas === 2) {
        navigate('/login');
        return;
      } else {
        toast(
          ({ closeToast }) => (
            <div className="custom-toast">
              <img
                alt="imagem de perfil da carol, assistente virtual dos correios"
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />
              <br />
              <p style={{ textAlign: 'justify' }}>
                Cliente Correios, o dado informado em {campoComErro} não está de
                acordo com o seu cadastro.
                <br />
              </p>
              <button
                onClick={() => {
                  closeToast();
                }}
              >
                OK
              </button>
            </div>
          ),
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: false, // Isso impede que o toast feche automaticamente
            closeOnClick: false, // Isso impede que o toast feche ao clicar
            closeButton: false,
          },
        );
        setTemErro(false);
        return;
      }
    }
    setTemErro(false);
    const celular = dadosUsuario.dddMovel + dadosUsuario.foneMovel;
    const dados = [
      dadosUsuario.idCorreios,
      ipAddress,
      data.meioEnvio,
      dadosUsuario.email,
      celular,
    ];
    navigate('/redefinirSenha', { state: dados });
  };
  useEffect(() => {
    if (temErro) setTentativas((prevTentativas) => prevTentativas + 1);
  }, [temErro]);
  const mascararEmail = (email) => {
    if (email) {
      const [usuario, dominio] = email.split('@');
      const usuarioMascarado = usuario.slice(0, 3) + 'xxx';
      return `${usuarioMascarado}@${dominio}`;
    } else {
      return '';
    }
  };
  return (
    <>
      <div className="conteudo">
        <div id="recuperar-senha" className="card bg-superficie elev5">
          <img
            alt="imagem de perfil da carol, assistente virtual dos correios"
            id="img-carol-boasvindas"
            src="/images/carol-perfil.png"
          />
          <h1>Esqueceu a senha?</h1>
          <label htmlFor="idCorreios">
            <h5>
              Informe o seu CNPJ ou Usuário caso não tenha CNPJ. Ao inserir o
              CNPJ, informar apenas os números e letras sem formatação.
            </h5>
          </label>
          <InputCadastro
            type="text"
            id="idCorreios"
            name="idCorreios"
            defaultValue={dadosUsuario?.idCorreios}
            //disabled={true}
            {...formMethods}
          />
          <div className="btns-row">
            <button
              id="btn-prosseguir"
              //onClick={handleIdCorreios}
              className="btn-pre"
              //disabled={true}
            >
              Prosseguir
            </button>
            <button
              className="btn-txt btn-fecha-dialog"
              onClick={() => navigate('/login')}
            >
              Cancelar
            </button>
          </div>
          {dadosUsuario?.usuarioExternoPJ.an8 && (
            <>
              <form
                id="formEsqueciSenha"
                onSubmit={methods.handleSubmit(handleSubmit)}
              >
                <InputCadastro
                  type="text"
                  id="an8"
                  name="an8"
                  placeholder=""
                  label="AN8*"
                  {...formMethods}
                />
                <InputNomeCompleto
                  type="text"
                  id="nome"
                  name="nome"
                  placeholder=""
                  label="Razão social*"
                  {...formMethods}
                />
                <InputCadastro
                  type="text"
                  id="nomeFantasia"
                  name="nomeFantasia"
                  label="Nome fantasia"
                  placeholder=""
                  {...formMethods}
                />
                {dadosUsuario.usuarioExternoPJ.ddiMovel != '55' ? (
                  <div className="radio-container">
                    <div className="titulo-radio subtitulo-p">
                      <hr />
                      <br />
                      Como deseja receber o token de recuperação da senha?
                    </div>
                    <label className="radio">
                      <Input
                        type="radio"
                        id="E"
                        name="meioEnvio"
                        value="E"
                        defaultChecked
                        {...formMethods}
                      />
                      <div className="subtitulo-p">
                        E-mail ({mascararEmail(dadosUsuario?.email)}){' '}
                      </div>
                    </label>

                    <label className="radio">
                      <Input
                        type="radio"
                        id="C"
                        name="meioEnvio"
                        value="C"
                        //disabled="true"
                        {...formMethods}
                      />
                      <div className="subtitulo-p">
                        Celular ({dadosUsuario?.dddMovel}){' '}
                        {dadosUsuario?.foneMovel?.substring(0, 2)}xxx-xx
                        {dadosUsuario?.foneMovel?.substring(7)}
                      </div>
                    </label>
                  </div>
                ) : (
                  <>
                    <label>
                      Seu token de confirmação de cadastro será enviado para o
                      E-mail ({mascararEmail(dadosUsuario?.email)}) .
                    </label>
                  </>
                )}
                <div className="btns-row">
                  <button
                    id="btn-voltar"
                    type="button"
                    className="btn-txt"
                    onClick={() => navigate('/login')}
                  >
                    Cancelar
                  </button>
                  <button id="btn-prosseguir" className="btn-pre" type="submit">
                    Alterar Senha
                  </button>
                </div>
              </form>
            </>
          )}
          <hr />
          <h6 className="ainda-problema">Ainda com problemas?</h6>
          <p className="legenda">
            Caso tenha perdido acesso ao e-mail e telefone informados no
            cadastro, abra uma manifestação no{' '}
            <a
              href="https://faleconosco.correios.com.br/cadastro/reclamacao-mc"
              className="txt-link"
            >
              Fale Conosco
            </a>
            . Solicite a atualização do e-mail no cadastro Meu Correios,
            informando o CNPJ, razão social e e-mail atual.
          </p>
        </div>
      </div>
    </>
  );
};
export default EsqueciSenhaPJAN8;
